import reducers from "./forgotPasswordReducers";

export default reducers;
